import { CSSProperties } from 'react';
import { Sparkles } from 'lucide-react';
import { useTranslation } from '../../../lib/i18n';
import { useGenericBi } from '../../../lib/use-generic-bi';
import { Button, Card, Typography } from '../ui';
import styles from './BriefSlot.module.css';
import { upgradeHref } from '../../../lib/upgrade-origin';

// Mobile-card rendering of the credit-paused "unlock morning meetings" brief state — the flat desktop
// content (`UpgradeBrief`) presented as a quiet floating `Card`, matching `MobileActivateBrief`'s
// shape but reading as an offer (sparkles + the accent upgrade CTA), not a nag. Mirrors the native
// `BriefUpgradeCard`s.

// Body copy — same pinned metrics as MobileActivateBrief's body (Wix Madefor Text 14/20, -0.42px,
// black): the `.sym-*` type variants out-specify the module class and carry 18px / -0.02em.
const BODY_TEXT: CSSProperties = {
  fontFamily: 'var(--brand-font-ui)',
  fontSize: 14,
  fontWeight: 'var(--sym-weight-semibold)',
  lineHeight: '20px',
  letterSpacing: '-0.42px',
  color: 'rgb(var(--ink-rgb))',
  fontFeatureSettings: "'dlig' on",
};

export function MobileUpgradeBrief() {
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();

  return (
    <Card component="section" style={{ textAlign: 'start' }} aria-labelledby="brief-upgrade-title">
      <p className={styles.eyebrow}>
        <Sparkles size={16} aria-hidden />
        <Typography variant="h4" color="strong" component="span" id="brief-upgrade-title">
          {t('brief.upgrade.title')}
        </Typography>
      </p>
      <p className={styles.mobileBody} style={BODY_TEXT}>
        {t('brief.upgrade.body')}
      </p>
      <div className={styles.mobileCta}>
        <Button
          color="accent"
          href={upgradeHref('brief_upgrade')}
          onClick={() => {
            logPageClickBi({ page_name: 'home', button_name: 'brief_upgrade' });
          }}
        >
          {t('brief.upgrade.cta')}
        </Button>
      </div>
    </Card>
  );
}
